module.exports = __webpack_public_path__ + "static/media/ilkley-20.e6864b0f.jpg";